// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--24cdb","text":"contact-module--text--3ckyn"};